import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _class, _class2, _descriptor, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "2392drFeO5BdYSWrQSqcDQ5", "Guide", undefined);

import { _decorator, Component, v3, Sprite, UITransform } from 'cc';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var Guide = (_dec = ccclass('Guide'), _dec2 = property(Sprite), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Guide, _Component);

  function Guide() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "sp_hand", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_radius", 375 * 375);

    _defineProperty(_assertThisInitialized(_this), "_x_l", 0);

    _defineProperty(_assertThisInitialized(_this), "_x_r", 0);

    _defineProperty(_assertThisInitialized(_this), "_x_cur", 0);

    _defineProperty(_assertThisInitialized(_this), "_centerPos", v3());

    _defineProperty(_assertThisInitialized(_this), "_interval", 40);

    return _this;
  }

  var _proto = Guide.prototype;

  _proto.onLoad = function onLoad() {
    var _trs = this.node.getComponent(UITransform);

    this._x_l = -_trs.contentSize.width / 2;
    this._x_r = -this._x_l;
    this._x_cur = this._x_l;
  };

  _proto.onDestroy = function onDestroy() {
    // GameCtr.I.removeEventListener();
    this.removeEventListener();
  };

  _proto.addEventListenr = function addEventListenr() {// App.EventMgr.addEventLintener(E_EventType.Guide_ActorTouchWheel, this.handle_touchWheel, this);
  };

  _proto.removeEventListener = function removeEventListener() {
    App.EventMgr.removeEvent(this);
  };

  _proto.onEnable = function onEnable() {
    this.updateHanderPos(this._x_cur);
  };

  _proto.start = function start() {
    this.addEventListenr();
  };

  _proto.updateHanderPos = function updateHanderPos(x) {
    var y = -Math.sqrt(this._radius - x * x);
    this.sp_hand.node.setPosition(v3(x, y, 0));
  };

  _proto.update = function update(dt) {
    if (this._interval > 0) {
      this._interval--;

      if (this._interval == 0) {
        this._x_cur = this._x_l;
        this.updateHanderPos(this._x_l);
      }
    } else {
      this._x_cur += 10;
      this.updateHanderPos(this._x_cur);

      if (this._x_cur > this._x_r) {
        this._interval = 40;
      }
    }
  };

  return Guide;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "sp_hand", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();